import queryString from 'query-string';
import { takeLatest, call, put } from 'redux-saga/effects';

import authService from 'services/authService';

import { getPaperlessTerms } from 'store/session/sagas';

import history from 'utils/browserHistory';

import { types, signUp } from './actions';

export function* initSignUpPage() {
  yield call(getPaperlessTerms);
}

function* watchSignUp(action) {
  try {
    const leadSource = queryString.parse(window.location.search).leadSource;
    yield call(authService.signUp, action.payload);
    yield put(signUp.success({ email: action.payload.email }));
    history.push(
      leadSource === 'online_metals' ? '/confirmation' : '/security',
    );
  } catch (e) {
    yield put(signUp.error(e));
  }
}

function* rootSaga() {
  yield takeLatest(types.SIGN_UP_REQUEST, watchSignUp);
}

export default rootSaga;
